import { SVGProps } from 'react';
//TODO: @ matheusgrandi: replace the variants with a prop instead of creating multiple components for the same icon
const ArrowIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M3.4541 12H21.4541H3.4541Z" fill="currentColor" />
    <path
      d="M10.4541 19L3.4541 12M3.4541 12L10.4541 5M3.4541 12H21.4541"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

export const LeftArrowIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <ArrowIcon {...props} />
);

export const RightArrowIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <ArrowIcon {...props} style={{ transform: 'rotate(180deg)' }} />
);

export const BottomArrowIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <ArrowIcon {...props} style={{ transform: 'rotate(-90deg)' }} />
);

export default ArrowIcon;
